import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import axios from "axios";
import Sidebar from "../componenteExtra/SidebarSolicitante";
import { Toaster, toast } from "react-hot-toast";
import SessionManager from '../componenteExtra/SessionManager';

const EsperaDocumentos = () => {
  const navigate = useNavigate();
  const [actividades, setActividades] = useState([]);
  const [selectedIds, setSelectedIds] = useState(new Set()); // ← Selección por ID
  const [nombre_get, setNombreGet] = useState("");
  const [selectedRazonSocial, setSelectedRazonSocial] = useState("");
  const [selectedFilial, setSelectedFilial] = useState("");

  const token = localStorage.getItem("access_token");

  // Cargar nombre_get
  useEffect(() => {
    const storedNombreGet = localStorage.getItem("nombre_get");
    setNombreGet(storedNombreGet || "");
  }, []);

  // Cargar actividades
  useEffect(() => {
    if (!nombre_get || !token) return;

    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/test_asignacion_get_solicitante/${nombre_get}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        const data = response.data || [];
        setActividades(data);
        setSelectedIds(new Set()); // Reinicia selección al cargar
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        toast.error("Error al cargar actividades");
      });
  }, [nombre_get, token]);

  // Toggle selección por ID
  const toggleRow = (id) => {
    setSelectedIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  // Filtros
  const filteredActividades = actividades.filter((actividad) => {
    const matchesRazon = !selectedRazonSocial || actividad.razon_social === selectedRazonSocial;
    const matchesFilial = !selectedFilial || actividad.filial === selectedFilial;
    return matchesRazon && matchesFilial;
  });

  const uniqueRazonSocial = [...new Set(actividades.map(a => a.razon_social).filter(Boolean))].sort();
  const uniqueFiliales = [...new Set(actividades.map(a => a.filial).filter(Boolean))].sort();

  const totalActividades = filteredActividades.length;

  // Obtener ID único (usa `id` si existe, si no, clave compuesta)
  const getUniqueId = (actividad) => {
    return actividad.id 
      ? actividad.id 
      : `${actividad.codigo_proyecto}-${actividad.razon_social}-${actividad.filial}`;
  };

  const handleContinue = async () => {
    const selectedActivities = actividades.filter((act) =>
      selectedIds.has(getUniqueId(act))
    );

    if (selectedActivities.length === 0) {
      toast.error("Selecciona al menos una actividad");
      return;
    }

    const currentDate = new Date().toISOString().split("T")[0];
    const toastId = toast.loading("Guardando documentación...");

    try {
      const updatedActivities = selectedActivities.map((actividad) => ({
        ...actividad,
        estado_asignaciones: actividad.estado_asignaciones + 1,
        fecha_documentación_actividad: currentDate,
      }));

      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/test_asignacion_get2`,
        updatedActivities,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.dismiss(toastId);
      toast.success("Documentación agregada correctamente");
      setTimeout(() => navigate("/menusolicitante"), 1500);
    } catch (error) {
      console.error("Error al guardar:", error);
      toast.dismiss(toastId);
      toast.error("Error al guardar documentación");
    }
  };

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <div className="main-panel">
          <h1>Solicitudes por documentar - {nombre_get}</h1>
          <h2>Total Actividades: {totalActividades}</h2>

          {/* FILTROS DESPLEGABLES */}
          <div className="filter-section" style={{ marginBottom: "20px", fontSize: "14px" }}>
            <label htmlFor="razonSocialFilter">| Razón Social: </label>
            <select
              id="razonSocialFilter"
              value={selectedRazonSocial}
              onChange={(e) => setSelectedRazonSocial(e.target.value)}
              style={{ padding: "5px", minWidth: "220px", marginRight: "15px" }}
            >
              <option value="">Todas</option>
              {uniqueRazonSocial.map((razon, i) => (
                <option key={i} value={razon}>
                  {razon}
                </option>
              ))}
            </select>

            <label htmlFor="filialFilter">| Filial: </label>
            <select
              id="filialFilter"
              value={selectedFilial}
              onChange={(e) => setSelectedFilial(e.target.value)}
              style={{ padding: "5px", minWidth: "180px" }}
            >
              <option value="">Todas</option>
              {uniqueFiliales.map((filial, i) => (
                <option key={i} value={filial}>
                  {filial}
                </option>
              ))}
            </select>
          </div>

          {/* TABLA */}
          <table className="activities-table">
            <thead>
              <tr>
                <th>Solicitar trabajo</th>
                <th>Código de proyecto</th>
                <th>Razón social</th>
                <th>Filial</th>
                <th>Tipo de trabajo</th>
                <th>Regulación</th>
                <th>Socio de auditoría</th>
                <th>Rubro</th>
                <th>Actividad</th>
                <th>Grupo</th>
                <th>Jefe de Grupo</th>
                <th>Subrogante</th>
                <th>Fecha de entrega de la información</th>
                <th>Fecha de termino de la actividad</th>
                <th>Fecha Corte Auditoría</th>
                <th>Enlace</th>
              </tr>
            </thead>
            <tbody>
              {filteredActividades.map((actividad) => {
                const id = getUniqueId(actividad);
                return (
                  <tr key={id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedIds.has(id)}
                        onChange={() => toggleRow(id)}
                      />
                    </td>
                    <td>{actividad.codigo_proyecto}</td>
                    <td>{actividad.razon_social}</td>
                    <td>{actividad.filial}</td>
                    <td>{actividad.tipo_solicitud}</td>
                    <td>{actividad.tipo_regulacion}</td>
                    <td>{actividad.encargado_auditoria}</td>
                    <td>{actividad.rubro_get}</td>
                    <td>{actividad.nombre_actividad_get}</td>
                    <td>{actividad.numero_grupo}</td>
                    <td>{actividad.jefe_grupo}</td>
                    <td>{actividad.subrogante}</td>
                    <td>{actividad.fecha_entrega_informacion}</td>
                    <td>{actividad.fecha_termino_senior_actividad}</td>
                    <td>{actividad.fecha_corte_auditoria}</td>
                    <td>
                      {actividad.enlace_comentario ? (
                        <a
                          href={actividad.enlace_comentario}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#0066cc", textDecoration: "underline" }}
                        >
                          Ver Documentación
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {filteredActividades.length === 0 && (
            <p style={{ textAlign: "center", color: "#666", margin: "20px 0" }}>
              
            </p>
          )}

          <button className="continue-button" onClick={handleContinue}>
            Continuar
          </button>
        </div>
      </div>
      <Toaster position="top-right" />
    </div>
  );
};

export default EsperaDocumentos;